import { FC } from 'react'
import {
  IconPaths,
  ModalSize,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import Swal from 'sweetalert2'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import {
  getContatoOfAgendamentoByEmpresa,
  getEmpresaById,
  getEsusConfigEmpresa,
  getLogo,
  toggleStatusEmpresa,
} from '../../core/_requests'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { EmpresaDtoUpdate, EmpresaList } from '../../core/_models'
import { EmpresaEditModalForm } from '../../components/modal/EmpresaEditModalForm'
import { EsusConfigModal } from '../../../../unidades/unidades-list/components/modal/EsusConfigModal'
import { useNavigate } from 'react-router-dom'
import { useT } from '_metronic/i18n/Metronici18n'
import { getTiposAtendimentos } from '_metronic/helpers/crud-helper/_request'

type Props = {
  empresa: EmpresaList
}

export const EmpresasActionsCell: FC<Props> = ({ empresa }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { t } = useT()

  const { refetch } = useQueryResponse()
  const navigate = useNavigate()
  const nome = empresa.nomeFantasia || empresa.nome || t('empresa.label')

  const openEditModal = () => {
    showModal({
      title: `${t('empresa.label')}`,
      content: <EmpresaEditModalForm />,
      size: ModalSize.ExtraLarge,
      fetchers: {
        logo: () => getLogo(empresa.id),
        empresa: () => getEmpresaById(empresa.id),
        contato: () => getContatoOfAgendamentoByEmpresa(Number(empresa.id)),
        tiposAtendimento: () => getTiposAtendimentos(),
      },
    })
  }

  const openEsusConfigModal = () => {
    showModal({
      title: `Configuração e-SUS APS (Padrão) — ${empresa.nomeFantasia || ''}`,
      content: <EsusConfigModal empresaId={Number(empresa.id)} onSaved={refetch} />,
      fetchers: {
        config: () => getEsusConfigEmpresa(Number(empresa.id)),
      },
    })
  }

  const setStatus = async (ativa: boolean) => {
    try {
      showAlertLoading()
      const data: EmpresaDtoUpdate = {
        id: Number(empresa.id),
        cnpj: String(empresa.cnpj),
        ativa,
      }
      await toggleStatusEmpresa(Number(empresa.id), data)
      Swal.close()
      showToast({ variant: 'success', title: `${nome} foi ${ativa ? 'ativada' : 'inativada'}.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  // Inativar pede confirmação explicando a consequência; ativar é reversível e não pede.
  const askInativar = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Inativar instituição?',
      text: `${nome} deixará de aparecer para novos atendimentos e agendamentos. Clientes, valores e histórico continuam guardados, e você pode reativá-la quando quiser.`,
      confirmButtonText: 'Inativar',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (confirmed) await setStatus(false)
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: 'Alterar', onClick: openEditModal, icon: IconPaths.Pen }}
      items={[
        { label: 'Configuração e-SUS', onClick: openEsusConfigModal },
        {
          label: 'Gerenciar valores',
          onClick: () =>
            navigate(`financeiro/${empresa.id}`, { state: { nome: empresa.nomeFantasia } }),
        },
        {
          label: 'Listar clientes',
          onClick: () => navigate(`clientes/${empresa.id}`),
          hidden: !empresa.permiteCadastroCliente,
        },
        {
          label: 'Listar endereços',
          onClick: () => navigate(`/apps/enderecos/instituicao/${empresa.id}`),
        },
        empresa.ativa
          ? { label: 'Inativar', onClick: askInativar, danger: true, divider: true }
          : { label: 'Ativar', onClick: () => setStatus(true), divider: true },
      ]}
    />
  )
}
